<template>
  <div>
    <div style="position: relative">
      <v-text-field
        v-model="item.title"
        class="rounded-lg"
        dense
        label="Заголовок (макс. 65 символов)"
        outlined
        :rules="[rules.required, rules.maxLength(65)]"
        aria-required="true"
        :disabled="!!item.processed_at"
      ></v-text-field>
      <div
        style="
          position: absolute;
          right: 2px;
          top: 2px;
          display: flex;
          flex-direction: row;
          gap: 0px;
        "
      >
        <EmojiPicker
          @emoji="addEmojiToTitle"
          v-if="!item.processed_at"
        />
      </div>
    </div>
    <div style="position: relative">
      <v-textarea
        :value="item.body"
        @input="item.body = $event || null"
        class="mt-4 rounded-lg"
        dense
        label="Описание (макс. 178 символов)"
        outlined
        :rules="[rules.maxLength(178)]"
        :disabled="!!item.processed_at"
      ></v-textarea>
      <div
        style="
          position: absolute;
          right: 2px;
          top: 2px;
          display: flex;
          flex-direction: column;
          gap: 0px;
        "
        v-if="!item.processed_at"
      >
        <EmojiPicker @emoji="addEmojiToDescription" />
        <v-menu>
          <template v-slot:activator="{ on }">
            <v-btn
              v-on="on"
              icon
            >
              <v-icon>mdi-alphabetical-variant</v-icon>
            </v-btn>
          </template>
          <v-card
            flat
            class="pa-2"
          >
            <div class="text-body-1 font-weight-bold mb-2">Макросы</div>
            <v-btn
              v-for="placeholder in placeholders"
              :key="placeholder.value"
              depressed
              @click="addPlaceholderToDescription(placeholder)"
            >
              <div class="text-none">
                {{ placeholder.label }}
                <v-tooltip
                  bottom
                  v-if="placeholder.defaultValue"
                >
                  <template v-slot:activator="{ on }">
                    <v-icon
                      small
                      class="ml-1"
                      v-on="on"
                      >mdi-information-outline</v-icon
                    >
                  </template>
                  <span>Значение по умолчанию: "{{ placeholder.defaultValue }}"</span>
                </v-tooltip>
              </div>
            </v-btn>
          </v-card>
        </v-menu>
      </div>
    </div>
    <v-text-field
      :value="item.accept_button_text"
      @input="item.accept_button_text = $event || null"
      class="rounded-lg mt-4"
      dense
      label="Текст кнопки модального окна"
      outlined
      :disabled="!!item.processed_at"
    ></v-text-field>

    <v-select
      class="rounded-lg mt-4"
      dense
      label="Тип ссылки"
      :items="localSubjectTypeList"
      v-model="localSubjectType"
      item-text="label"
      item-value="value"
      outlined
      :disabled="!!item.processed_at"
    ></v-select>
    <v-text-field
      v-if="localSubjectType === localSubjectTypeEnum.EXTERNAL_LINK"
      v-model="item.external_link"
      class="rounded-lg mt-4"
      dense
      label="Внешняя ссылка"
      outlined
      :rules="[rules.required, rules.maxLength(128)]"
      aria-required="true"
      :disabled="!!item.processed_at"
    ></v-text-field>
    <v-select
      v-else-if="localSubjectType === localSubjectTypeEnum.APP_PAGE"
      class="rounded-lg mt-4"
      dense
      label="Страница приложения"
      :items="$notification.appLinks.filter(v => v.value.startsWith('app_'))"
      :value="subjectTypeId"
      @input="item.subject_type = $event"
      item-value="value"
      item-text="label"
      :rules="[rules.required]"
      aria-required="true"
      outlined
      :disabled="!!item.processed_at"
    ></v-select>
    <v-autocomplete
      v-if="subjectIdModel"
      label="Связанный элемент"
      class="rounded-lg mt-4"
      dense
      outlined
      :disabled="!!item.processed_at"
      v-model="item.subject_id"
      :items="subjectIdModelItems"
      item-value="value"
      item-text="label"
      :return-object="false"
      :rules="[rules.required]"
      aria-required="true"
    >
      <template v-slot:append>
        <v-progress-circular
          v-if="subjectIdModelLoading"
          size="20"
          width="2"
          indeterminate
          color="primary"
        ></v-progress-circular>
      </template>
    </v-autocomplete>
    <v-row
      align="center"
      class="mt-4"
      no-gutters
    >
      <div class="text-h6 mr-3">Изображение</div>
      <v-divider />
    </v-row>
    <ImageUploader
      :key="imageKey"
      title="Основная картинка"
      class="mb-8"
      height="200"
      width="355"
      @input="uploadImage($event, 'image')"
      :image="item.image"
    ></ImageUploader>
  </div>
</template>
<script>
  import rules from 'air-vue-model/rules'
  import { defineComponent } from 'vue'
  import EmojiPicker from '@/components/helpers/EmojiPicker.vue'
  import { cloneDeep, isObject } from 'lodash'
  import PushPreviewIos from '@/admin/views/notifications/notificationPage/PushPreviewIos.vue'
  import { userNotificationPlaceholders } from '@/services/userNotificationPlaceholders'
  import LazySelect from '@/components/helpers/LazySelect.vue'
  import ImageUploader from '@/admin/components/ImageUploader'

  export default defineComponent({
    name: 'DetailData',
    components: { LazySelect, PushPreviewIos, EmojiPicker, ImageUploader },
    props: {
      item: Object
    },
    data: () => {
      const localSubjectTypeEnum = {
        APP_PAGE: 1,
        EXTERNAL_LINK: 2
      }
      const localSubjectTypeName = {
        [localSubjectTypeEnum.APP_PAGE]: 'Страница приложения',
        [localSubjectTypeEnum.EXTERNAL_LINK]: 'Внешняя ссылка'
      }
      return {
        placeholders: userNotificationPlaceholders,
        localSubjectType: localSubjectTypeEnum.APP_PAGE,
        localSubjectTypeEnum,
        notificationImageToSave: null,
        imageKey: 1,
        localSubjectTypeList: Object.keys(localSubjectTypeName).map(_key => {
          const key = Number(_key)
          return {
            label: localSubjectTypeName[key],
            value: key
          }
        })
      }
    },
    mounted() {
      if (this.item.subject_type === this.$notification.appLinkTypeEnum.EXTERNAL_LINK) {
        this.localSubjectType = this.localSubjectTypeEnum.EXTERNAL_LINK
      }
      this.loadDataBySubjectTypeId(this.item.subject_type)
    },
    computed: {
      rules() {
        return {
          ...rules,
          maxLength: p => v => (v?.length ?? 0) <= p || `Максимальная длина ${p}`
        }
      },
      subjectTypeId() {
        const subjectType = this.item.subject_type
        if (!subjectType) return null
        if (isObject(subjectType)) return subjectType.id
        return subjectType
      },
      subjectIdModel() {
        const mapping = {
          [this.$notification.appLinkTypeEnum.APP_PRODUCT_PAGE]: this.$product,
          [this.$notification.appLinkTypeEnum.APP_PROMO_PAGE]: this.$promo
        }
        return mapping[this.item.subject_type] || null
      },
      subjectIdModelLoading() {
        return this.subjectIdModel?.loadings?.list || false
      },
      subjectIdModelItems() {
        const mapping = new Map()
        mapping.set(this.$product, {
          label: 'vendor_name|name',
          value: 'id',
          kek: true
        })
        mapping.set(this.$promo, {
          label: 'name',
          value: 'id'
        })

        const items = this.subjectIdModel?.list || []
        const res = items.map(v => {
          const mappingItem = mapping.get(this.subjectIdModel)
          if (!mappingItem) throw Error('Mapping not found')

          const getFirstNonEmptyValue = (obj, fields) => {
            const fieldList = fields.split('|')
            for (const field of fieldList) {
              if (obj[field]) return obj[field]
            }
            return ''
          }

          return {
            label: mappingItem.label.includes('|')
              ? getFirstNonEmptyValue(v, mappingItem.label)
              : v[mappingItem.label],
            value: String(v[mappingItem.value])
          }
        })
        return res.sort((a, b) => a.label.localeCompare(b.label))
      }
    },
    methods: {
      async uploadImage(file, field) {
        if (!this.item.id) {
          return new Promise(resolve => {
            const reader = new FileReader()
            reader.readAsDataURL(file)
            this.notificationImageToSave = file
            reader.onload = () => {
              Object.assign(this.item, { [field]: reader.result })
              this.imageKey++
            }
            resolve(this.item)
          })
        } else {
          var currentItem = cloneDeep(this.item)

          if (this.isObject(currentItem.subject_type)) {
            currentItem.subject_type = currentItem.subject_type.id
          }

          if (this.isObject(currentItem.notification_type)) {
            currentItem.notification_type = currentItem.notification_type.id
          }

          const formData = new FormData()
          formData.append('image', file)
          formData.append('type', field)

          const res = await axios.patch(`/notifications/${this.item.id}/`, formData, {
            headers: {
              'Content-Type': 'multipart/form-data'
            }
          })

          this.item.image = res.image
          this.imageKey++

          this.$store.commit('setSnackbar', {
            color: 'success',
            text: 'Изображение сохранено'
          })

          return res
        }
      },
      isObject(item) {
        return item && typeof item === 'object'
      },
      addPlaceholderToDescription(placeholder) {
        if (!this.item.body) this.item.body = placeholder.value
        else {
          let v = placeholder.value
          if (!this.item.body.endsWith(' ')) v = ` ${v}`
          this.item.body += v
        }
      },
      addEmojiToDescription(emoji) {
        if (!this.item.body) this.item.body = emoji
        else this.item.body += emoji
      },
      addEmojiToTitle(emoji) {
        if (!this.item.title) this.item.title = emoji
        else this.item.title += emoji
      },
      loadDataBySubjectTypeId(v) {
        const model = this.subjectIdModel
        if (!model) {
          this.item.subject_id = null
          return
        }
        if (v === this.$notification.appLinkTypeEnum.APP_PROMO_PAGE) {
          model.loadList({ page_size: 'all' })
        } else if (v === this.$notification.appLinkTypeEnum.APP_PRODUCT_PAGE) {
          model.loadList({ page_size: 'all' })
        }
      },
      afterSave() {
        if (this.notificationImageToSave) {
          return this.uploadImage(this.notificationImageToSave, 'image')
        } else {
          console.log('huina')
        }
      }
    },
    watch: {
      subjectTypeId(v) {
        console.log('set subject_id', v)

        this.item.subject_type = v
        this.loadDataBySubjectTypeId(v)
      },
      localSubjectType(v) {
        if (
          v === this.localSubjectTypeEnum.EXTERNAL_LINK &&
          this.item.subject_type !== this.$notification.appLinkTypeEnum.EXTERNAL_LINK
        ) {
          this.item.subject_type = this.$notification.appLinkTypeEnum.EXTERNAL_LINK
          this.subjectTypeId = null
        } else if (v !== this.localSubjectTypeEnum.EXTERNAL_LINK) {
          this.item.external_link = null
        }
      }
    }
  })
</script>

<style scoped>
  :deep(.v-text-field__details) {
    position: absolute;
    bottom: -20px;
  }

  :deep(.v-textarea .v-input__slot),
  :deep(.v-text-field .v-input__slot) {
    padding-right: 40px !important;
  }
</style>
